/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} United_KingdomInputs */

const en_united_kingdom = /** @type {(inputs: United_KingdomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`United Kingdom`)
};

const es_united_kingdom = /** @type {(inputs: United_KingdomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reino Unido`)
};

const fr_united_kingdom = /** @type {(inputs: United_KingdomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Royaume-Uni`)
};

const de_united_kingdom = /** @type {(inputs: United_KingdomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vereinigtes Königreich`)
};

const ja_united_kingdom = /** @type {(inputs: United_KingdomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イギリス`)
};

const zh_united_kingdom = /** @type {(inputs: United_KingdomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`英国`)
};

const ar_united_kingdom = /** @type {(inputs: United_KingdomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المملكة المتحدة`)
};

const id_united_kingdom = /** @type {(inputs: United_KingdomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inggris Raya`)
};

const it_united_kingdom = /** @type {(inputs: United_KingdomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regno Unito`)
};

const ru_united_kingdom = /** @type {(inputs: United_KingdomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Великобритания`)
};

const pt_united_kingdom = /** @type {(inputs: United_KingdomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reino Unido`)
};

const ko_united_kingdom = /** @type {(inputs: United_KingdomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`영국`)
};

/**
* | output |
* | --- |
* | "United Kingdom" |
*
* @param {United_KingdomInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const united_kingdom = /** @type {((inputs?: United_KingdomInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<United_KingdomInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_united_kingdom(inputs)
	if (locale === "es") return es_united_kingdom(inputs)
	if (locale === "fr") return fr_united_kingdom(inputs)
	if (locale === "de") return de_united_kingdom(inputs)
	if (locale === "ja") return ja_united_kingdom(inputs)
	if (locale === "zh") return zh_united_kingdom(inputs)
	if (locale === "ar") return ar_united_kingdom(inputs)
	if (locale === "id") return id_united_kingdom(inputs)
	if (locale === "it") return it_united_kingdom(inputs)
	if (locale === "ru") return ru_united_kingdom(inputs)
	if (locale === "pt") return pt_united_kingdom(inputs)
	return ko_united_kingdom(inputs)
});